var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsSelect = function SvgMillustrationsSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    fill: "#000",
    fillOpacity: 0.04,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 13,
    x: 8.5,
    y: 4.5,
    fill: "#fff",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 12,
    y: 9,
    fill: "#CCCCD9",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    d: "M39.48 10.664C38.905 10.02 39.363 9 40.226 9h3.546c.863 0 1.32 1.02.748 1.664l-1.774 1.995a1 1 0 0 1-1.494 0z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 13,
    x: 8.5,
    y: 4.5,
    stroke: "#B6B2FF",
    rx: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 17,
    x: 8.5,
    y: 18.5,
    fill: "#fff",
    rx: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 4,
    x: 12,
    y: 22,
    fill: "#CCCCD9",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 12,
    y: 28,
    fill: "#CCCCD9",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 17,
    x: 8.5,
    y: 18.5,
    stroke: "#B6B2FF",
    rx: 1.5
  })));
};
export default SvgMillustrationsSelect;